<header class="site-header sticky-top">
  <section>
    <div class="logo" style="padding: 20px 1.1em;">
      <a [routerLink]="'/' + shareModel.urlPath.Dashboard">
        <span class="logo-icon"><img src="../assets/images/logo_icon.png"></span>
        <span class="logo-text"><img src="../assets/images/logo_text.png"></span>
      </a>
    </div>
  </section>
</header>

<div class="content">
  <div class="container help-content">
    <div class="page-title api">
      <h1 translate class="float-left">API Terms of use</h1>
      <span>Last Updated on 2024/04/17</span>
    </div>
    <div class="page-terms api">
      <ul class="style-none style-padding">
        <li>
          <h5><span>1.</span>Account Registration</h5>
          <ul class="style-none">
            <li>
              <div class="flex">
                <p class="number">1.1.</p>
                <p>In order to access or use CyberPower PowerPanel Cloud APIs, or other APIs provided by CyberPower (collectively “APIs”), you are required to register an active Account. You may be
                  required to pay for the use of APIs service. Please be sure the information you provide to CyberPower will always be accurate and up to date.</p>
              </div>
            </li>
            <li>
              <div class="flex">
                <p class="number">1.2.</p>
                <p>Please do not use the APIs if (a) you are not of legal age to accept this API Terms of Use, or (b) you are barred from using or receiving any API under the applicable laws, or (c)
                  you disagree any section of this API Terms of Use.</p>
              </div>
            </li>
          </ul>
        </li>
        <li>
          <h5><span>2.</span>Restrictions and Prohibitions</h5>
          <ul class="style-none">
            <li>
              <div class="flex">
                <p class="number">2.1.</p>
                <p>CyberPower retains the right to restrict the number of requests that you may make or the number of users you may serve. The limits for requests or number of users will be defined by
                  CyberPower at its sole discretion from time to time. If you surpass the defined limit, CyberPower may temporarily suspend your access to the APIs. Any attempts to bypass these
                  specified limits may result in the suspension to use the APIs or the termination of these terms of use without CyberPower prior notice. If you would like to use the APIs beyond these
                  limits, please obtain CyberPower’s prior express consent (and CyberPower may decline such request or condition acceptance on your agreement to additional terms and/or charges for
                  that use). </p>
              </div>
            </li>
            <li>
              <div class="flex">
                <p class="number">2.2.</p>
                <p>You shall only use the APIs into your application for checking the status of your device. You will not use the APIs in any manner or for any purpose other than as expressly
                  permitted by these Terms of Use. The APIs is subject to the following restrictions: </p>
              </div>
              <ol type="I">
                <li>You may access, use or display the APIs on a computer or other device only in strict accordance with the related API Documentation, and only for the specific purposes stated in
                  these Terms of Use.</li>
                <li>Additionally, unless expressly mandated or authorized by applicable law, you are prohibited, and shall not allow any third party to:
                  <ol type="a">
                    <li>Employ the APIs for any unlawful, infringing, or malicious purposes, including but not limited to the development or implementation of software, applications, or services that
                      involve spyware or other malicious programs or code.</li>
                    <li>Attempt to bypass any security measures or technical limitations of the APIs.</li>
                    <li>Utilize the APIs to upload or transmit viruses or other computer code designed to interrupt, destroy, or limit the functionality of Connected Devices or any third-party
                      software, firmware, or hardware associated with Connected Devices.</li>
                    <li>Interfere with the operability of the APIs, Connected Devices, serves, networks or any third-party software, firmware, or hardware with whom Connected Devices communicates or
                      interfaces.</li>
                    <li>Engage in the modification, adaptation, translation, reverse engineering, decompilation, disassembly, or any attempt to reconstruct the source code of the APIs, except to the
                      extent prohibited by applicable law. CyberPower reserves the right to correct errors, bugs, or defects in the APIs, where permitted by law.</li>
                    <li>Resell or sublicense the APIs or offer them as a commercial product or service.</li>
                    <li>Sub-license, lease, outsource, or rent the APIs or provide access to them, or allow a third party to use the APIs for their own or others' benefit.</li>
                    <li>Directly or indirectly violate any export control laws or regulations by exporting, re-exporting, downloading, or shipping the APIs.</li>
                    <li>Defame, abuse, harass, stalk, or threaten others.</li>
                    <li>Promote of facilitate unlawful online gambling or disruptive commercial messages or advertisements.</li>
                    <li>Use the APIs for any activities where the use or failure of the APIs lead to death, personal injury or environmental damage (such as aviation control or life support systems).
                    </li>
                    <li>Use the APIs for any military purpose or nuclear operation.</li>
                  </ol>
                </li>
                <li>Any violation of these prohibitions above will result in the immediate and automatic termination of using the API at CyberPower sole discretion.</li>
                <li>You commit to using the APIs only in a manner that aligns with the laws of the jurisdiction where you remotely utilize them. This includes, but is not limited to, compliance with
                  applicable regulations regarding copyright and other Intellectual Property Rights. You are prohibited from using the APIs to attempt, or in conjunction with any device, program, or
                  service designed to circumvent technological measures employed to control access to, or the rights in, a content file or other work protected by the copyright laws of any
                  jurisdiction.</li>
              </ol>
            </li>
          </ul>
        </li>
        <li>
          <h5><span>3.</span>Data Privacy</h5>
          <ul class="style-none">
            <li>Yor are advised to review CyberPower Privacy Policy which can be viewed at: https://www.cyberpower.com/global/en/policy/privacy and any privacy notice(s) associated with the APIs,
              provided by CyberPower. You have responsibility for any third-party Personal Information that you upload, store, create, use, share, modify, delete, transfer, or otherwise process during
              and/or through your utilization of the APIs. It is imperative that you adhere to all relevant laws and regulations, obtain necessary consents, and fulfill all required notifications in
              this regard.</li>
          </ul>
        </li>
        <li>
          <h5><span>4.</span>Confidentiality-</h5>
          <ul class="style-none">
            <li>The APIs and communication between us may contain CyberPower Confidential Information. CyberPower Confidential Information includes any materials, keys, communications and information
              that are marked confidential or that would normally be considered confidential under the circumstance. You are permitted to use CyberPower Confidential Information solely in conjunction
              with your utilization of the APIs and under these Terms of Use. You are prohibited from disclosing CyberPower Confidential Information for any reason unless with CyberPower prior written
              consent or when compelled to do so by law if you provide CyberPower reasonable prior notice, unless a court orders that we not receive notice. You are obligated to implement all
              reasonable measures to prevent the disclosure, dissemination, or unauthorized use of CyberPower Confidential Information, employing, at a minimum, the same measures you apply to
              safeguard your own confidential information of a similar nature.</li>
          </ul>
        </li>
        <li>
          <h5><span>5.</span>Publicity</h5>
          <ul class="style-none">
            <li>Without CyberPower's prior express written consent, you are not allowed to issue any press release or make any public communication concerning the use of APIs which suggests
              partnership with, sponsorship by, or endorsement by CyberPower.</li>
          </ul>
        </li>
        <li>
          <h5><span>6.</span>Liability for the APIs</h5>
          <ol type="I">
            <li>
              <p>Warranty</p>
              <p>The APIs we provide “as is”. CyberPower makes no warranty as to its use or performance, compatibility, appropriateness, other performance, or the performance or results you may obtain
                by using it. CyberPower make no warranties, express or implied, as to noninfringement of third-party rights, merchantability, or fitness for any particular purpose. CyberPower make no
                warranties, express or implied, as to noninfringement of third-party rights, merchantability, or fitness for any particular purpose. CyberPower exclude all warranties, guarantees,
                conditions, representations, and undertakings.</p>
            </li>
            <li>Limitation of Liability
              <p>Regardless of the basis on which you are entitled to claim damages from CyberPower (including material breach, negligence, misrepresentation, or other contract or tort claim),
                CyberPower’s entire liability for all claims in the aggregate arising from or related to the APIs or otherwise arising under this API Terms of use will not exceed the amount of any
                actual direct damages up to the greater of THE RETAIL PRICE PAID FOR the APIs (OR UP TO $50 USD IF YOU ACQUIRED the APIs FOR NO CHARGE).
                In no event will CyberPower, its directors, officers, employees, and suppliers be liable to you for injury or damage to business, profits, revenues, data or your goodwill or for any
                punitive damage, consequential or incidental damages, however caused, whether for breach of warranty, breach of contract, repudiation of contract, termination, negligence, or
                otherwise, even if it has been advised of the possibility of such damages.
                In all cases, CyberPower, its directors, officers, employees, and suppliers will not be liable for any expense, loss or damage that is not reasonably foreseeable.
              </p>
            </li>
            <li>Indemnification
              <p>Unless prohibited by applicable law, you will defend and indemnify CyberPower and its directors, officers, employees, suppliers and users against all liabilities, damages, losses,
                costs, fees, and expenses relating to any allegation or third- party legal proceeding to the extent from:</p>
              <ol type="a">
                <li>your misuse of the APIs;</li>
                <li>your violation of this API terms of use; or</li>
                <li>any content or date routed into or used with the APIs by you or acting on your behalf.</li>
              </ol>
            </li>
          </ol>
        </li>
        <li>
          <h5><span>7.</span>Amendments to these Terms of Use</h5>
          <ul class="style-none">
            <li>CyberPower retains the right, at its sole discretion, to modify any portion of this Terms of Use at any time. Any such changes will be posted by CyberPower on the relevant webpage(s)
              of CyberPower PowerPanel Cloud. It is recommended that every user of the APIs should regularly check for updates, and it is your responsibility to review the current Terms of Use before
              utilizing the APIs. Your continued use of the APIs constitutes your acceptance of the modified Terms . If you do not agree with any such modifications, you should discontinue your use of
              the APIs.</li>
          </ul>
        </li>
        <li>
          <h5><span>8.</span>Term</h5>
          <ul class="style-none">
            <li>The Agreement will commence on the date when you use the APIs and remain in effect until termination.</li>
          </ul>
        </li>
        <li>
          <h5><span>9.</span>Title and Right</h5>
          <ol type="i">
            <li>
              CyberPower retain all rights, title, and interest in the APIs, along with all associated technology and Intellectual Property Rights. The APIs is protected by United States Copyright
              Law, Patent Law, applicable laws and International Treaty provisions. Your use of the APIs does not grant you any right, title, and interest. Your infringement of any intellectual
              property right retained by CyberPower shall immediately terminate your use of the APIs and this API Terms of Use at CyberPower’s sole discretion.
            </li>
            <li>
              Should you become aware of any actual or potential infringement or misappropriation of the proprietary or other Intellectual Property Rights of CyberPower or its/their licensors
              concerning the APIs or the mentioned trademarks, service marks, service or trade names, logos, or other designations, you must promptly inform CyberPower of such infringement or
              misappropriation. Additionally, you are required to provide all pertinent information necessary for CyberPower to safeguard its interests.
            </li>
          </ol>
        </li>
        <li>
          <h5><span>10.</span>No Assignment</h5>
          <ul class="style-none" style="padding-left: 32px;">
            <li>You shall not assign this API Terms of Use, API Key, or any data or information provided by CyberPower to others without CyberPower’s prior written notice. The violation of this
              assignment will constitute the material breach of this API Terms of Use. </li>
          </ul>
        </li>
        <li>
          <h5><span>11.</span>Termination</h5>
          <ol type="i" class="ml-12">
            <li>
              Any violation of this API Terms of Use shall immediately terminate your use of the APIs without prior notice or refund. You may also terminate this API Terms of Use by stopping using the
              APIs with or without notice. if you want to terminate this API Terms of Use, you must provide us with prior written notice and upon termination, cease your use of the applicable APIs. We
              reserves the right to terminate the Terms with you or discontinue any applicable APIs or any portion or feature or your access thereto for any reason and at any time without liability or
              other obligation to you.
            </li>
            <li>
              Upon any termination of this API Terms of Use or discontinuation of your access to an API of CyberPower, you will immediately stop using the API, cease all use of the date, application,
              information, interface from CyberPower and delete any cached or stored content from CyberPower.
            </li>
            <li>
              When this API Terms of Use terminated, those terms that by their nature are intended to continue indefinitely will continue to apply, including but not limited to: Sections 2,4,6 and 9.
            </li>
          </ol>
        </li>
        <li>
          <h5><span>12.</span>General Terms</h5>
          <ol type="i" class="ml-12">
            <li>The API Terms of Use do not create any third party beneficiary rights or any agency, partnership, or joint venture.</li>
            <li>CyberPower are not liable for failure or delay in performance to the extent caused by circumstances beyond our reasonable control. If you do not comply with the API Terms of Use, and
              CyberPower does not take action right away, this does not mean that we are giving up any rights that it may have (such as taking action in the future).
            </li>
            <li>CyberPower means Cyber Power Systems, Inc. and any one of its subsidiaries or affiliated companies (“CyberPower”).</li>
            <li>The API Terms of Use are the entire agreement between you and CyberPower relating to its subject and supersede any prior or contemporaneous agreements on that subject.</li>
            <li>The API Terms of Use will be governed by the laws of the State of Minnesota, U.S.A., excluding the application of its conflicts of law rules. This API Terms of Use will not be governed
              by the United Nations Convention on Contracts for the International Sale of Goods, the application of which is expressly excluded. </li>
            <li>If any part of this this API Terms of Use is found void and unenforceable, it will not affect the validity of the balance of this API Terms of Use, which shall remain valid and
              enforceable according to its terms. </li>
          </ol>
        </li>
      </ul>
    </div>
  </div>

</div>
